import {Inject, Injectable} from '@angular/core';
import * as angular from "angular";
import {BaseFieldService} from "@/angular-blocworx/components/fields/BaseFieldService";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Configuration} from "@/angular-blocworx/components/configuration/services/configuration.service";
import {RequestService} from "@/angular-blocworx/components/configuration/services/request.service";
import {DataFiltering} from "@/legacy/controllers/DataFiltering.interface";
import {lastValueFrom} from "rxjs";
import {BehaviorSubject, Observable} from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class DataGeneratorService extends BaseFieldService {

    private triggerDataGeneratorFromFieldActions: Function;
    private triggerDataGeneratorViaForcedRefreshList: Function;
    private clearDataGenerator: Function;
    private currentEntries: any = {};
    private currentColumnOrders: [];
    private currentTableColumns: any = {};
    private _currentDataGeneratorData: any = {}

    private entriesSubject = new BehaviorSubject<any>(null);
    private columnOrdersSubject = new BehaviorSubject<any>(null);
    private tableColumnsSubject = new BehaviorSubject<any>(null);

    constructor(
        @Inject(HttpClient) protected http: HttpClient,
        @Inject(Configuration) protected configuration: Configuration,
        @Inject(RequestService) protected request: RequestService
    ) {
        super(http, configuration, request);
    }

    // Getter to access the stored data
    get currentDataGeneratorData(): any {
        return this._currentDataGeneratorData;
    }

    // Method to set the data
    setCurrentDataGeneratorData(data: any, fieldId): void {
        this._currentDataGeneratorData[fieldId] = data;
    }

    getInitialParams() {

        return {
            'dataGeneratorStationAndFields': {
                'subParameters': {
                    'stationId': {
                        'validation': {
                            'required': false,
                            'validationResponse': 'Please choose a Bloc to look up',
                            'requiredType': 'stringMustNotBeEmpty'
                        }
                    },
                    'localFieldId': {
                        'validation': {
                            'required': false
                        }
                    },
                    'remoteFieldId': {
                        'validation': {
                            'required': false
                        }
                    }

                },
                'validation': {
                    'required': false,
                    'validationResponse': 'Please select a bloc and a field to look up',
                    'requiredType': 'listMustHaveOne'
                }
            },
            'dataGeneratorDestinationStationAndFields': {
                'subParameters': {
                    'stationId': {
                        'validation': {
                            'required': false,
                            'validationResponse': 'Please choose a Bloc to look up',
                            'requiredType': 'stringMustNotBeEmpty'
                        }
                    },
                    'localFieldId': {
                        'validation': {
                            'required': false
                        }
                    },
                    'remoteFieldId': {
                        'validation': {
                            'required': false
                        }
                    }

                },
                'validation': {
                    'required': false,
                    'validationResponse': 'Please select a bloc and a field to look up',
                    'requiredType': 'listMustHaveOne'
                }
            },
            'copyingTriggerEvent': {
                'validation': {
                    'required': false
                }
            },
            'copyingButtonText': {
                'validation': {
                    'required': false
                }
            },
            'triggerActionsAfterCopying': {
                'validation': {
                    'required': false
                }
            },
            'dataGeneratorEditorApplyBlocInitialisation': {
                'validation': {
                    'required': false
                }
            },
            'dataGeneratorApplyFieldActions': {
                'validation': {
                    'required': false
                }
            },
            'dataGeneratorPreSubmitFeatures': {
                'validation': {
                    'required': false
                }
            },

            'onlyApplyFieldActionsFieldArray': {
                'validation': {
                    'required': false
                }
            },
            'fieldsToRefreshAfterCompletion': {
                'validation': {
                    'required': false
                }
            },
            'localFieldMatchingFieldPairs': {
                'validation': {
                    'required': false
                }
            },
            'sourceDestinationFieldMatchingPairs': {
                'validation': {
                    'required': false
                }
            },
            'localDestinationFieldMatchingPairs': {
                'validation': {
                    'required': false
                }
            },
            'askUserConfirmation': {
                'validation': {
                    'required': false
                }
            },
            'confirmationPopupText': {
                'validation': {
                    'required': false
                }
            },
            'dataGeneratorType': {
                'validation': {
                    'required': false,
                    'defaultValue': 'dataGenerator'
                }
            },
            'recurringDataPrimaryDateFieldFormat': {
                'validation': {
                    'required': false,
                    'defaultValue': 'YYYY-MM-DD'
                }
            },
            'recurringDataExpectedFormats': {
                'validation': {
                    'required': false,
                }
            },
            'recurringDataDontReplace': {
                'validation': {
                    'required': false,
                }
            },
            "recurringDataButtonText": {
                "validation": {
                    "required": false,
                }
            },
            "primaryDateFieldId": {
                'validation': {
                    'required': false,
                }
            },
            'recurringDataExplanationText': {
                'validation': {
                    'required': false,
                }
            },
            'applyChangesToRecurringDataText': {
                'validation': {
                    'required': false,
                }
            },
            'doNotApplyChangesToRecurringDataText': {
                'validation': {
                    'required': false,
                }
            },
            'applyChangesToThisAndFutureEventsText': {
                'validation': {
                    'required': false,
                }
            },
            "dataGeneratorEditorApplyBlocInitialisationAfterLines": {
                "validation": {
                    "required": false,
                }
            },
            "dataGeneratorApplyFieldActionsAfterLines": {
                'validation': {
                    'required': false,
                }
            },
            'dataGeneratorPreSubmitFeaturesAfterLines': {
                'validation': {
                    'required': false,
                }
            } ,
            'onlyApplyFieldActionsFieldArrayAfterLines': {
                'validation': {
                    'required': false,
                }
            },
            'recurringDataAffectedResultsBoxes': {
                'validation': {
                    'required': false,
                }
            },
            'whenActionHappensActionsFieldId': {
                'validation': {
                    'required': false
                }
            }
        }
    }



    /**
     * This function will be responsible for the building the colour/value combination
     *
     * @param valueBasedCellColours
     * @param value
     * @param colour
     */
    addValueColourCombination = (valueBasedCellColours, value, colour) => {

        if (value == null || colour == null) {
            alert('Please choose a value/colour combination');
            return valueBasedCellColours;
        }


        if (valueBasedCellColours == null || typeof valueBasedCellColours == 'undefined' || (typeof valueBasedCellColours != 'undefined' && valueBasedCellColours.length == 0) || (typeof valueBasedCellColours === 'object' && Object.keys(valueBasedCellColours).length == 0)) {
            valueBasedCellColours = [];
        }

        // rebuild to an array if its an object
        if (typeof valueBasedCellColours === 'object' && Object.keys(valueBasedCellColours).length > 0) {
            let temporaryArray = [];


            for (let i = 0; i < Object.keys(valueBasedCellColours).length; i++) {
                temporaryArray.push(valueBasedCellColours[i]);
            }


            valueBasedCellColours = temporaryArray;
        }

        valueBasedCellColours.push({
            'value': value,
            'colour': colour
        });

        return valueBasedCellColours;
    }

    /**
     * This will be responsible to remove value colour combinations
     *
     * @param valueBasedCellColours
     * @param index
     */
    removeValueColourCombination = (valueBasedCellColours, index = null) => {


        let temporaryArray = [];

        let i = 0;
        for (let j = 0; j < Object.keys(valueBasedCellColours).length; j++) {
            if (j != index) {
                temporaryArray[i] = valueBasedCellColours[j];
                i++;
            }
        }

        valueBasedCellColours = temporaryArray;


        return valueBasedCellColours;
    }

    /**
     * This will be responsible to remove from the list of fields that we are only showing
     *
     * @param onlyShowFieldArray
     * @param index
     */
    removeDataGeneratorOnlyShowField = (onlyShowFieldArray, index = null) => {

        if (index == null) {
            alert('Please Select a field');
            return onlyShowFieldArray;
        }

        delete onlyShowFieldArray[index];

        // build new object with fresh keys to keep it in sync
        let fieldListForLoop = onlyShowFieldArray;
        onlyShowFieldArray = [];
        let i = 0;

        for (let i = 0; i < fieldListForLoop.length; i++) {
            onlyShowFieldArray[i] = fieldListForLoop[i];
        }

        return onlyShowFieldArray;
    }


    getDataForDataFiltering = async (dataFilteringData, fieldIdOrFieldSlug): Promise<any> => {

        let apiBase: string = this.evervaultEnabledApiUrl + 'get-data-for-data-filtering';

        let dataFilteringDataString = JSON.stringify(dataFilteringData);

        let params = new HttpParams()
            .set('dataFilteringData', dataFilteringDataString)
            .set('fieldIdOrFieldSlug', fieldIdOrFieldSlug)
            .set('resultLimit', dataFilteringData.resultLimit);

        let headers = this.request.getHeaders();

        const response = this.http.get(apiBase, {params, headers});

        return lastValueFrom(response);
    }


    public getScanStationFields = (scanStationID): Promise<any> => {
        const headers = this.request.getHeaders()

        const body = {
            scanStationID,
        }
        const response = this.http.post(`${this.apiUrl}get-scan-station-fields`, body, {headers});
        return lastValueFrom(response)
    }


    public triggerFieldActionsForSingleRecordInDataGenerator = (dataGeneratorFieldData, saveData, field): Promise<any> => {
        const headers = this.request.getHeaders()

        const body = {
            dataGeneratorFieldData: dataGeneratorFieldData,
            saveData: saveData,
            dataGeneratorEditorApplyBlocInitialisation: field.dataGeneratorEditorApplyBlocInitialisation,
            dataGeneratorApplyFieldActions: field.dataGeneratorApplyFieldActions,
            dataGeneratorPreSubmitFeatures: field.dataGeneratorPreSubmitFeatures,
            dataGeneratorMakeSearchable: field.dataGeneratorMakeSearchable,
            dataGeneratorUpdateLoggedInUserForInline: field.dataGeneratorUpdateLoggedInUserForInline,
            triggerSourcefieldId: field.id
        }
        const response = this.http.post(`${this.apiUrl}trigger-field-actions-for-single-record-in-data-generator`, body, {headers});
        return lastValueFrom(response)
    }

    getDataFilteringDataForDataGenerator = (parseResults, scanStationID, filteringData = '', scanStationFieldIdsToField, dataToAdd) => {
        try {

            if (parseResults == null) {
                return null;
            }

            let dataFilteringData = <DataFiltering>{};
            dataFilteringData.stationID = parseResults.scanStationID;
            dataFilteringData.resultLimit = 500;
            dataFilteringData.currentPage = 1;
            dataFilteringData.filterDataToQuery = {};

            if (parseResults.localFieldMatchingFieldPairs != null && Object.keys(parseResults.localFieldMatchingFieldPairs).length > 0) {

                let fieldMatchingPairsLength = Object.keys(parseResults.localFieldMatchingFieldPairs).length;

                for (let i = 0; i < fieldMatchingPairsLength; i++) {
                    dataFilteringData.filterDataToQuery[parseResults.localFieldMatchingFieldPairs[i].remoteFieldId] = [dataToAdd[scanStationFieldIdsToField[parseResults.localFieldMatchingFieldPairs[i].localFieldId].field_slug]];
                }

            } else {
                dataFilteringData.filterDataToQuery[parseResults.dataGeneratorRemoteFieldId] = [filteringData];
            }

            dataFilteringData.currentStationID = scanStationID;
            dataFilteringData.reverse = parseResults.dataGeneratorReverseOption;

            if (parseResults.sortByFieldId != null) {
                dataFilteringData.sortByFieldId = parseResults.sortByFieldId;
            }

            return dataFilteringData;

        } catch (e) {
            console.log(e)
        }
    }


    /**
     * These functions allow us to call functions in the parent component, this means they can be called
     * from any other component or angularjs controller
     * @param fn
     */
    public setTriggerDataGeneratorFromFieldActions(fn: Function) {
        this.triggerDataGeneratorFromFieldActions = fn;
    }

    public callTriggerDataGeneratorFromFieldActions(fieldId) {
        if (this.triggerDataGeneratorFromFieldActions) {
            return this.triggerDataGeneratorFromFieldActions(fieldId);
        }
    }

    public setTriggerDataGeneratorViaForcedRefreshList(fn: Function) {
        this.triggerDataGeneratorViaForcedRefreshList = fn;
    }

    public callTriggerDataGeneratorViaForcedRefreshList(fieldsToRefreshAfterCompletion) {
        if (this.triggerDataGeneratorViaForcedRefreshList) {
            return this.triggerDataGeneratorViaForcedRefreshList(fieldsToRefreshAfterCompletion);
        }
    }

    public setTriggerClearDataGenerator(fn: Function) {
        this.clearDataGenerator = fn;
    }

    public callTriggerClearDataGenerator(fieldSlug) {
        if (this.clearDataGenerator) {
            return this.clearDataGenerator(fieldSlug);
        }
    }

    get entries$() {
        return this.entriesSubject.asObservable();
    }

    updateEntries(newData: any) {
        this.currentEntries = newData;
        this.entriesSubject.next(newData);
    }

    get columnOrders$() {
        return this.columnOrdersSubject.asObservable();
    }

    updateColumnOrders(newData: any) {
        this.currentColumnOrders = newData;
        this.columnOrdersSubject.next(newData);
    }

    get tableColumns$() {
        return this.tableColumnsSubject.asObservable();
    }

    updateTableColumns(newData: any) {
        this.currentTableColumns = newData;
        this.tableColumnsSubject.next(newData);
    }

    addCurrentDataGeneratorFieldToRefreshList = (dataGeneratorField) => {
        // if dataGeneratorField.fieldsToRefreshAfterCompletion either doesnt exist or is an empty object or is just an object which only contains dataGeneratorField.id then create an array and add dataGeneratorField.id to it
        if (dataGeneratorField.fieldsToRefreshAfterCompletion == null || Object.keys(dataGeneratorField.fieldsToRefreshAfterCompletion).length == 0 || (Object.keys(dataGeneratorField.fieldsToRefreshAfterCompletion).length == 1 && dataGeneratorField.fieldsToRefreshAfterCompletion[dataGeneratorField.id] != null)) {
            dataGeneratorField.fieldsToRefreshAfterCompletion = [dataGeneratorField.id];
        }
        // else if it does not contain dataGeneratorField.id then add it to the array, but if its an object firstly convert it to an array
        else if (dataGeneratorField.fieldsToRefreshAfterCompletion[dataGeneratorField.id] == null) {
            if (!Array.isArray(dataGeneratorField.fieldsToRefreshAfterCompletion)) {
                dataGeneratorField.fieldsToRefreshAfterCompletion = Object.values(dataGeneratorField.fieldsToRefreshAfterCompletion);
            }
            dataGeneratorField.fieldsToRefreshAfterCompletion.push(dataGeneratorField.id);

        }

        return dataGeneratorField;
    }

    getAllCurrentDataGeneratorColumnOrders() {
        return this.currentColumnOrders;

    }


    getAllCurrentDataGeneratorTableColumns() {
        return this.currentTableColumns;

    }

    getAllCurrentDataGeneratorData() {
        return {
            'entries': this.currentEntries,
            'columnOrders': this.currentColumnOrders,
            'tableColumns': this.currentTableColumns
        }

    }

    restoreAllCurrentDataGeneratorData(dataGeneratorData: any) {
        this.updateEntries(dataGeneratorData.entries);
        this.updateColumnOrders(dataGeneratorData.columnOrders);
        this.updateTableColumns(dataGeneratorData.tableColumns);
    }

    public triggerDataGeneratorAction = async ( fieldId: string, localFieldData: any): Promise<any> => {
        const headers = this.request.getHeaders()

        const body = {
            fieldId: fieldId,
            localFieldData: localFieldData,
        }

        const response = this.http.post(`${this.apiUrl}trigger-data-generator-action`, body, {headers});
        return lastValueFrom(response)
    }

    public triggerRecurringData = async (recurringData, recordId, editingRecord): Promise<any> => {
        const headers = this.request.getHeaders()

        const body = {
            recurringData: recurringData,
            recordId: recordId,
            editingRecord: editingRecord
        }

        const response = this.http.post(`${this.apiUrl}trigger-recurring-data`, body, {headers});
        return lastValueFrom(response)
    }
 
}
